<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
  <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

    <!-- Slide 1 -->
    <div class="carousel-item active">
      <div class="carousel-container">
        <ng-lottie [options]="Futbol" (animationCreated)="animationCreated($event)"></ng-lottie>
        <h2 class="animate__animated animate__fadeInDown">Bienvenido a la <span>diversión</span></h2>
        <p class="animate__animated fanimate__adeInUp">Con nuestra aplicación podrás de manera muy fácil crear un
          QUINIELA y disfrutar
          con familiares y amigos de los pronósticos acertados en los partidos. Está diseñada para llevar
          un control sencillo de los puntajes que van acumulando los participantes al finalizar cada partido. </p>
        <div class="row">
          <div class="col-sm">
            <a (click)="scroll('about')" class="btn-get-started animate__animated animate__fadeInUp scrollto">
              ¡Leer mas!
            </a>
          </div>
          <div class="col-sm" *ngIf="!isAuthenticated">
            <a [routerLink]="['/register']" class="btn-get-started animate__animated animate__fadeInUp scrollto">
              ¡Registrate!
            </a>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
  <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 24 150 28 " preserveAspectRatio="none">
    <defs>
      <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
    </defs>
    <g class="wave1">
      <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
    </g>
    <g class="wave2">
      <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
    </g>
    <g class="wave3">
      <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
    </g>
  </svg>
</section><!-- End Hero -->

<!-- ======= About Section ======= -->
<div class="container">
  <div class="row">
    <div class="col-sm">
      <section id="about" class="about">
        <div class="container">

          <div class="section-title" data-aos="zoom-out">
            <p>¿Quienes somos...?</p>
            <h2>Acerca de nosotros</h2>
          </div>

          <div class="row content" data-aos="fade-up">
            <div class="col-lg-12">
              Somos un equipo de trabajo para el diseño y desarrollo de aplicaciones WEB, lo que en la actualidad
              permite que
              estas se puedan ejecutar en ordenadores y en telefonos inteligentes. Las características principales de
              una aplicación WEB:
              <p>
              </p>
              <ul>
                <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i>
                  Pueden ser ejecutadas desde cualquier navegador</li>
                <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> No
                  tienen problemas de compatibilidad</li>
                <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> No
                  ocupan espacio en tu disco duro</li>
              </ul>
            </div>
          </div>

        </div>
      </section><!-- End About Section -->
    </div>
    <div class="col-sm">
      <section id="about" class="about">
        <div class="container">

          <div class="section-title" data-aos="zoom-out">
            <p>¿Qué es una QUINIELA?</p>
            <h2>Crear una QUINIELA?</h2>
          </div>

          <div class="row content" data-aos="fade-up">
            <div class="col-lg-12">
              <p>
                Juego de apuestas en el cual los participantes rellenan un formulario
                con los pronósticos de los resultados de cierta competición deportiva, enfocado
                especialmente en partidos de fútbol. En la medida que acierten resultados
                van acumulando puntos, al final el premio se entrega al o a los participantes
                con el mayor puntaje obtenido.  El objetivo principal es divertirse entre amigos y conocidos, pero
                también
                podemos recaudar fondos para alguna acción benéfica que requiera obtener
                ayuda monetaria y en algunos casos para recabar fondos     
              </p>
              <!-- 
              <a [routerLink]="['/register']" class="btn-learn-more">¡Registrate y empieza a Crear tu Quiniela!</a>
               -->
            </div>
          </div>

        </div>
      </section><!-- End About Section -->
    </div>
  </div>
</div>

<!-- ======= Features Section ======= -->
<section id="features" class="features">
  <div class="container">

    <div class="section-title" data-aos="zoom-out">
      <p>Motivos para realizar una QUINIELA</p>
      <h2>Ejemplos</h2>
    </div>

    <ul class="nav nav-tabs row d-flex">
      <li class="nav-item col-3" data-aos="zoom-in">
        <a class="nav-link active show" data-toggle="tab" href="#tab-1">
          <i class="ri-money-dollar-box-fill"></i>
          <h4 class="d-none d-lg-block">Recaudar fondos para diversos eventos.</h4>
        </a>
      </li>
      <li class="nav-item col-3" data-aos="zoom-in" data-aos-delay="100">
        <a class="nav-link" data-toggle="tab" href="#tab-2">
          <i class="ri-hand-heart-line"></i>
          <h4 class="d-none d-lg-block">Obras Benéficas</h4>
        </a>
      </li>
      <li class="nav-item col-3" data-aos="zoom-in" data-aos-delay="200">
        <a class="nav-link" data-toggle="tab" href="#tab-3">
          <i class="ri-alarm-warning-fill"></i>
          <h4 class="d-none d-lg-block">Gastos sobrevenidos</h4>
        </a>
      </li>
      <li class="nav-item col-3" data-aos="zoom-in" data-aos-delay="300">
        <a class="nav-link" data-toggle="tab" href="#tab-4">
          <i class="ri-trophy-fill"></i>
          <h4 class="d-none d-lg-block">Solo por diversión</h4>
        </a>
      </li>
    </ul>

    <div class="tab-content" data-aos="fade-up">
      <div class="tab-pane active show" id="tab-1">
        <div class="row">
          <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h5
              style='margin: 0;margin: 0;font-weight: 700;text-transform: uppercase;font-family: "Poppins", sans-serif;color: #2a2c39;'>
              Recaudar fondos para diversos eventos.
            </h5>
            <ul>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Fondos Pro-Graduación (Pueden ser desde escolares a bachilleres o universitarios).</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Fondos para la adquisición de materiales deportivos para un equipo determinado.
              </li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Necesidad de adquirir uniformes para equipos deportivos o artístico.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Agasajos o reuniones para festejar algún logro.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Recabar para sostener algún paseo recreativo grupal</li>
            </ul>
          </div>
          <div class="col-lg-6 order-1 order-lg-2 text-center">
            <div class="container text-center" style="max-width: 350px;">
              <ng-lottie [options]="Cancha" (animationCreated)="animationCreated($event)"></ng-lottie>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="tab-2">
        <div class="row">
          <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h5
              style='margin: 0;margin: 0;font-weight: 700;text-transform: uppercase;font-family: "Poppins", sans-serif;color: #2a2c39;'>
              Obras Benéficas
            </h5>
            <ul>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Sostener programas beca/estudio.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Adquisicón de medicamentos para personas necesitadas.
              </li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Ayudas monetarias en caso de enfermedades.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Ayudas para casos de desastres naturales .</li>

            </ul>
          </div>
          <div class="col-lg-6 order-1 order-lg-2 text-center">
            <div class="container text-center" style="max-width: 350px;">
              <ng-lottie [options]="Cancha" (animationCreated)="animationCreated($event)"></ng-lottie>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="tab-3">
        <div class="row">
          <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h5
              style='margin: 0;margin: 0;font-weight: 700;text-transform: uppercase;font-family: "Poppins", sans-serif;color: #2a2c39;'>
              Gastos sobrevenidos
            </h5>
            <ul>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> En edificios: reparación de ascensores, filtraciones, pintura general, etc.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Reparación o instalación de sistemas de seguridad (CCTV, cerco electrico, rejas, etc.).
              </li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Campaña para reparar canchas deportivas o áreas verdes.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Comunitarios: costear eventos deportivos, artísticos, cursos, etc.</li>

            </ul>
          </div>
          <div class="col-lg-6 order-1 order-lg-2 text-center">
            <div class="container text-center" style="max-width: 350px;">
              <ng-lottie [options]="Cancha" (animationCreated)="animationCreated($event)"></ng-lottie>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="tab-4">
        <div class="row">
          <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
            <h5
              style='margin: 0;margin: 0;font-weight: 700;text-transform: uppercase;font-family: "Poppins", sans-serif;color: #2a2c39;'>
              Solo por diversión
            </h5>
            <ul>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Entretenernos con familiares y amigos.</li>
              <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;">
                </i> Divertirnos con colegas y compañeros de trabajo.</li>

            </ul>
          </div>
          <div class="col-lg-6 order-1 order-lg-2 text-center">
            <div class="container text-center" style="max-width: 350px;">
              <ng-lottie [options]="Cancha" (animationCreated)="animationCreated($event)"></ng-lottie>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section><!-- End Features Section -->

<!-- ======= Cta Section ======= -->
<section id="cta" class="cta" style="padding: 2rem 0;">
  <div class="container">
    <div class="container row" data-aos="zoom-out">
      <h3>Recomendaciones para crear y administrar una QUINIELA</h3>
      <p class="font-italic">
        Debemos tener presente en todo momento la transparencia en cuanto a los motivos, la fecha de comienzo y
        fin, la premiacion (%) y
        la información de la persona contacto. Se debe planificar de manera de dejar tiempo para publicitar, vender y
        entusiasmar a la mayor
        cantidad de participantes antes de la fecha del primer partido pautado. Informar hasta que fecha se
        aceptará participación.
      </p>
      <ul class="text-white" style="list-style: none;">
        <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> Definir de
          forma muy clara el motivo (Pro-fondos, diversión,
          benéfica, etc.).</li>
        <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> Definir la
          cantidad de partidos que se incluiran en la QUINIELA.
        </li>
        <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> Definir pote
          a repartir.</li>
        <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> Definir
          forma de pago (pago-movil, efectivo, etc.).</li>
        <li><i class="ri-check-double-line" style="font-size: 20px;padding-right: 4px;color: #ef6603;"></i> Al finalizar
          cada partido se debe actualizar la tabla con el
          resultado final, con esto
          de forma automática se acreditaran los puntos respectivos a quienes acertaron y se actualizará la tabla
          de posiciones.</li>
      </ul>
      <p>
        En todo momento los participantes podrán acceder a la pagina de la QUINIELA y consultar como va el pote a
        repartir, cantidad de
        participantes, tabla de posiciones, ver la quiniela de cualquier participante, etc.
        Cuando hayan finalizados todos los partidos la tabla de posiciones indicara quien o quienes son los
        felices ganadores de pote.
      </p>
    </div>
  </div>
</section><!-- End Cta Section -->